import React from "react";

import "./Title.scss";

interface TitleProps {
  text: string;
}

const Title: React.FC<TitleProps> = ({ text }) => {
  return <h1 className="table-title">{text}</h1>;
};

export default Title;
